/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { HStack, Icon, Text } from '@chakra-ui/react'
import React from 'react'
import { FiInfo } from 'react-icons/fi'

const styles = {
  warning: { bg: 'orange.100', color: 'orange.800' },
  error: { bg: 'red.100', color: 'red.800' },
  info: { bg: 'blue.50', color: 'blue.800' }
}

const Message = ({
  status,
  message
}) => {
  const { bg, color } = styles[status] || styles.info

  return (
    <HStack
      mt={0}
      pt={3}
      pl={3}
      bg={bg}
      borderRadius="md"
      align="flex-start"
      spacing={2}
    >
      { status === 'info' &&
        <Icon as={FiInfo} color={color} boxSize={4} mt="2px" />
      }
      <Text fontSize="sm" color={color}>
        { message }
      </Text>
    </HStack>
  )
}

export default Message
